import {
    SearchOverlayComponent as SourceSearchOverlayComponent,
} from 'SourceComponent/SearchOverlay/SearchOverlay.component';
import React from 'react';
import './SearchOverlay.override.style';
import { AMOUNT_OF_PLACEHOLDERS } from 'Src/component/ProductGallery/ProductGallery.config';
import Link from 'Component/Link';
import SearchItem from 'Src/component/SearchItem';

export class SearchOverlayComponent extends SourceSearchOverlayComponent {
    static propTypes = {
        closeSearch: this.propTypes
    }

    renderSearchItem(product, i) {
        const { closeSearch } = this.props;

        return (
            <SearchItem
                product={product}
                key={product.id || i}
                closeSearch={closeSearch}
            />
        );
    }

    renderSearchResults() {
        const { searchResults, isLoading } = this.props;

        if (!searchResults?.length) {
            return this.renderNoResults();
        }

        const resultsToRender = (isLoading || this.timeout) ? Array(AMOUNT_OF_PLACEHOLDERS).fill({}) : searchResults;

        return (
            <ul className="SearchOverlay-ItemsHolder">
                {resultsToRender.map((item, i) => this.renderSearchItem(item, i))}
            </ul>
        );
    }

    render() {
        const { closeSearch } = this.props;

        return (
            <article
                className="SearchOverlay-Results"
                aria-label="Search results"
            >
                <div className='SearchOverlay-CategoriesList'>
                    <div className='SearchOverlay-CategoriesListMenu'>
                        <h1>Categories</h1>

                        <div className='SearchOverlay-CategoriesLinks'>
                            <Link to={"/customize/ring-settings.html"} onClick={closeSearch}>
                                <span>Rings</span>
                            </Link>
                            <Link to={"/customize/ring-settings.html"} onClick={closeSearch}>
                                <span>earrings</span>
                            </Link>
                            <Link to={"/customize/ring-settings.html"} onClick={closeSearch}>
                                <span>bracelets</span>
                            </Link>
                            <Link to={"/customize/ring-settings.html"} onClick={closeSearch}>
                                <span>pendants</span>
                            </Link>
                        </div>
                    </div>

                    <div className='SearchOverlay-CategoriesListMenu'>
                        <h1>Diamonds</h1>

                        <div className='SearchOverlay-CategoriesLinks'>
                            <Link to={"/lab-grown-gemstone-rings.html"} onClick={closeSearch}>
                                <span>Gemstone</span>
                            </Link>
                            <Link to={"/customize/ring-diamond/natural-diamond.html?diamond_created_from=11"} onClick={closeSearch}>
                                <span>Diamonds</span>
                            </Link>
                            <Link to={"/coloreddiamond?diamond_created_from=11"} onClick={closeSearch}>
                                <span>Color Diamonds</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {this.renderSearchResults()}
            </article>
        );
    }
}

export default SearchOverlayComponent;
